export default {
	state: {
		shops: [
			{
				id: '001',
				street: 'ул. Красноармейская, дом 33',
				point: 'МАГНИТ'
			},
			{
				id: '002',
				street: 'ул. Мясникяна, дом 91',
				point: 'МАГНИТ'
			},
			{
				id: '003',
				street: 'ул. Ростовская, дом 10',
				point: 'МАГНИТ'
			},
			{
				id: '004',
				street: 'ул. Социалистическая, дом 56',
				point: 'МАГНИТ'
			}
		]
	},
	mutations: {},
	actions: {},

	getters: {
		getChaltir (state) {
			return state.shops
		}
	}
}